import React from "react";
import { Box, Grid, Typography, Paper, Card } from "@mui/material";

const steps = [
  {
    title: "Step 1",
    image:
      "https://elfsight.com/wp-content/uploads/2019/08/whatsapp-chat_screenshot-2.jpg",
    description:
      "Select a design that aligns with your brand for a seamless look and feel.",
  },
  {
    title: "Step 2",
    image:
      "https://elfsight.com/wp-content/uploads/2019/08/whatsapp-chat_screenshot-1.jpg",
    description:
      "Craft a personalized greeting and tailor the CTA button or widget to engage visitors effectively.",
  },
  {
    title: "Step 3",
    image:
      "https://elfsight.com/wp-content/uploads/2019/08/whatsapp-chat_screenshot-3.jpg",
    description:
      "Click ‘Generate Code’ to copy the widget into your site, and start connecting with your customers.",
  },
];

const GenerationSteps = () => {
  return (
    <Box
      sx={{
        py: 8,
        px: 2,
        display: "flex",
        justifyContent: "center",
        background: "linear-gradient(135deg, #c5e3f5 0%, #ddeffa 100%)",
      }}
    >
      <Box
        sx={{
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        {/* Main Heading */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontSize: { xs: "1.5rem", md: "2.5rem" },
            fontWeight: 600,
            mb: 2,
          }}
        >
          <Box component="span" sx={{ color: "#054e92" }}>
            Generate Your Free
          </Box>{" "}
          WhatsApp Live Chat Widget in Minutes
        </Typography>

        {/* Steps */}
        <Grid container spacing={3} mt={4}>
          {steps.map((step, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                sx={{
                  p: 4,
                  borderRadius: "16px",
                  textAlign: "left",
                  height: "100%",
                  background: '#fff',
                }}
              >
                <Box
                  sx={{
                    width: "auto",
                    height: 200,
                    mb: 2,
                  }}
                >
                  <img
                    src={step.image}
                    alt={`step-${index + 1}`}
                    width={"100%"}
                    height={"100%"}
                    style={{ objectFit: "cover" }}
                  />
                </Box>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  gutterBottom
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    color: "#000",
                    fontWeight: 600,
                  }}
                >
                  {step.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    color: "text.secondary",
                    fontWeight: 400,
                  }}
                >
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default GenerationSteps;
